<template>
    <div
            class="subscription"
    >
        <template v-if="!areSubscriptionsLoading">
            <div
                    class="subscription__item subscription__item_clickable"

            >
                <VChangableLabel
                        :counter="payingUsers"
                        @mouseover="showTooltip($event,'subscriptionTooltipPayingUsers',{data:subscriptionsByRenewal.active,offsets:{top:-15}})"
                >
                    <span
                    >paying users</span>
                </VChangableLabel>
            </div>
            <div
                    class="subscription__item subscription__item_clickable"

            >
                <VChangableLabel
                        :counter="activeTrialSubscriptionSum"
                        @mouseover="showTooltip($event,'subscriptionTooltip',{data:activeTrialSubscription,offsets:{top:-15}})"
                >
                    <span
                    >active trials</span>
                </VChangableLabel>
            </div>
            <div class="subscription__item subscription__item_clickable">
                <VChangableLabel
                        :counter="billingSubscriptionSum"
                        @mouseover="showTooltip($event,'subscriptionTooltip',{data:subscriptionsByRenewal.billing_retry,offsets:{top:-15}})"
                >
                    <span

                    >billing retry</span>
                </VChangableLabel>
            </div>
            <div class="subscription__item subscription__item_clickable">
                <VChangableLabel
                        :counter="graceSubscriptionSum"
                        @mouseover="showTooltip($event,'subscriptionTooltip',{data:subscriptionsByRenewal.grace_period,offsets:{top:-15}})"
                >
                    <span

                    > grace period</span>
                </VChangableLabel>
            </div>
            <div
                    class="subscription__item"
                    v-if="currentBoard.tempData && currentBoard.tempData.revenueSubscription !== null"
            >
                <VChangableLabel
                        :counter="currentBoard.tempData.revenueSubscription?currentBoard.tempData.revenueSubscription.toLocaleString('en') : ''"
                >
                    <template slot="prefix">$</template>
                    <template slot="default">revenue</template>
                </VChangableLabel>
            </div>
            <div
                    class="subscription__item"
                    v-if="currentBoard.tempData && currentBoard.tempData.costsSubscription !== null"
            >
                <VChangableLabel
                        :counter="currentBoard.tempData.costsSubscription.toLocaleString('en')"
                >
                    <template slot="prefix">$</template>
                    <template slot="default">costs</template>
                </VChangableLabel>
            </div>
            <template v-if="cohort && isAllowedPredict">
                <div
                        class="subscription__item subscription_last subscription__item_clickable"
                        v-if="predictions"
                >
                    <template v-for="predictType in predictTypes">
                        <VChangableLabel
                                :key="predictType"
                                :counter="getPredict(predictType)"
                                :small-counter="getPercentForSubscription(getPredict(predictType))"
                                @mouseover="showTooltip($event,'predictionTooltip',{data:{board:currentBoard,predictType},offsets:{top:-5}})"
                                @click="changePopupVisibility(predictType)"
                        >
                            <template
                                    v-if="predictions[`predict${predictType}`]"
                                    slot="prefix"
                            >$
                            </template>
                            <template slot="default">
                        <span
                        >rev.{{ predictType }}d </span>
                                <template v-if="!predictions[`predict${predictType}`]">
                                    <font-awesome-icon icon="fa-solid fa-clock"/>
                                </template>
                            </template>
                            <template slot="postfix">
                            </template>
                        </VChangableLabel>
                    </template>
                    <div
                            class="progress-vertical"
                            :class="`progress-vertical_${getConfidenceColor(predictions[`confidence90`])}`"
                    >
                        <div :style="{height:`${predictions[`confidence90`]*10}%`}"></div>
                    </div>
                </div>
                <template v-else-if="predictions">
                    <div class="not-calculated">Not calculated</div>
                </template>
                <template v-else>
                    <div
                            class="subscription__item subscription__item_loading"
                    >
                        <VLoadingRow width="135px"></VLoadingRow>
                        <VLoadingRow width="135px"></VLoadingRow>
                        <VLoadingRow width="135px"></VLoadingRow>
                    </div>
                </template>
                <template v-if="areSubscriptionsLoading">
                    <template v-for="(subscription) in 2">
                        <div
                                class="subscription__item subscription__item_loading"
                                :key="subscription"
                        >
                            <VLoadingRow width="135px"></VLoadingRow>
                        </div>
                    </template>
                </template>
            </template>
            <div
                    class="subscription-all-time-label"
                    v-if="!cohort"
            >
                ALL TIME
            </div>
            <div
                    class="refund"
                    v-if="cohort && isAllowedPredict"
            >
                <VInput
                        class="refund__input"
                        v-model="localRefundPercent"
                        :min="0"
                        :max="100"
                        :is-allow-fractional="true"
                        type="number"
                        @enter="applyRefund"
                ></VInput>
                %
                <VButton
                        class="refund__button"
                        type="button"
                        theme="positive"
                        @click="applyRefund"
                >
                    Set ref%
                </VButton>
            </div>
        </template>
        <template v-else>
            <template v-for="(subscription) in 6">
                <div
                        class="subscription__item subscription__item_loading"
                        :key="subscription"
                >
                    <VLoadingRow width="135px"></VLoadingRow>
                </div>
            </template>

        </template>
        <VFullScreenPopup
                v-if="isShowPopup"
                :title="`revenue ${currentPredictType}d`"
                :is-show-submit-button="false"
                :is-show-sidebar="false"
                :cancel-button-text="'OK'"
                @cancel="changePopupVisibility"
        >
            <div class="popup-body">
                <template v-if="!areSubscriptionsLoading">
                    <div
                            class="popup-body_text"
                            v-html="predictions.info"
                    ></div>
                    <div
                            class="popup-body_chart"
                            v-if="charts"
                    >
                        <template v-for="(chart,chartIndex) in charts">
                            <template v-if="chart.data.datasets.length">
                                <div
                                        class="popup-body_chart-copy"
                                        :key="chartIndex+100"
                                >
                                    <v-button
                                            v-if="chart.data.datasets.length"
                                            type="button"
                                            theme="dark-blue"
                                            @click="excelCopy(chart)"
                                    >
                                        Copy
                                    </v-button>
                                </div>
                                <component
                                        :key="chartIndex"
                                        :is="chartComponent"
                                        :chart-data="chart.data"
                                        :options="chart.options"
                                >
                                </component>
                            </template>
                        </template>
                    </div>
                </template>
                <template v-else>
                    Loading...
                </template>
            </div>
        </VFullScreenPopup>
    </div>
</template>

<script>
    import VChangableLabel from '../../components/VChangableLabel';
    import VLoadingRow from '../../components/VLoadingRow';
    import VFullScreenPopup from '../../components/VFullScreenPopup';
    import {getEventsWithData} from '../../api/apiServices';
    import {addTempBoardData, copyToClipboard, roundNumber} from '../../helpers/dataHelper';
    import {getConfidenceColor} from './mapping';
    import {getUrlParam} from '@/helpers/urlHelper';

    export default {
        name: 'Subscriptions',
        components: {
            VChangableLabel,
            VLoadingRow,
            VFullScreenPopup,
        },
        props: {
            cohort: {
                type: Boolean,
                required: false,
            },
            isDataUpdating: {
                type: Boolean,
                required: false,
            },
            areAdditionalSubscriptionsLoading: {
                type: Boolean,
                required: false,
            },
            subscriptions: {
                type: Array,
                required: false,
            },
            features: {
                type: Array,
                required: false,
            },
            currentBoard: {
                type: Object,
                required: false,
            },
        },
        data() {
            return {
                isShowPopup: false,
                charts: null,
                localRefundPercent: null,
                predictTypes: ['90', '180', '365'],
                currentPredictType: null,
                isAllowedPredict: false,
            };
        },
        created() {
            this.isAllowedPredict = getUrlParam('predict') && getUrlParam('predict') === 'true';
        },
        watch: {
            isDataUpdating: {
                immediate: true,
                handler(isUpdating) {
                    if (!isUpdating) {
                        this.getSubscriptionFromFeatureBundleId();
                        if (this.isAllowedPredict && (this.currentBoard.predictions?.displays ||
                            this.currentBoard.predictions[`products${this.currentPredictType}`])) {
                            this.generateCharts();
                            this.localRefundPercent = this.currentBoard.refundPercent || null;
                        }
                    }
                },
            },
        },
        computed: {
            areSubscriptionsLoading() {
                return this.isDataUpdating || this.currentBoard.tempData.areAdditionalSubscriptionsLoading;
            },
            subscriptionsByRenewal() {
                const subscriptions = {};
                this.subscriptions.forEach((subscription) => {
                    if (!subscriptions[subscription.renewal_info]) {
                        subscriptions[subscription.renewal_info] = [];
                    }
                    subscriptions[subscription.renewal_info].push(subscription);
                });
                return subscriptions;
            },
            payingUsers() {
                if (this.subscriptionsByRenewal.active) {
                    return this.subscriptionsByRenewal.active.filter((sub) => sub.discount_type !== 'trial').reduce(function (sum, subscription) {
                        return sum + subscription.count;
                    }, 0);
                }
                return 0;
            },
            billingSubscriptionSum() {
                return this.getSumByProperty('billing_retry');
            },
            graceSubscriptionSum() {
                return this.getSumByProperty('grace_period');
            },
            activeTrialSubscription() {
                if (this.subscriptionsByRenewal.active) {
                    return this.subscriptionsByRenewal.active.filter((sub) => sub.discount_type === 'trial');
                }
                return [];
            },
            activeTrialSubscriptionSum() {
                return this.activeTrialSubscription.reduce(function (sum, subscription) {
                    return sum + subscription.count;
                }, 0);
            },

            chartComponent() {
                const componentType = 'line';
                return () => import(`../../components/VFeatureBlock/VFeatureBlockCharts/VFeatureBlockChart-${componentType}.vue`);
            },
            predictions() {
                return this.currentBoard.predictions;
            },
        },
        methods: {
            getPercentForSubscription(subscriptionValue) {
                if (!subscriptionValue) {
                    return '';
                }
                const cost = this.currentBoard.tempData.costsSubscription;
                const value = roundNumber(100 * (subscriptionValue - cost) / cost);
                return `${value}%`;
            },
            getConfidenceColor,
            getPredict(predictType) {
                const originalPredict = this.predictions[`predict${predictType}`];
                if (!originalPredict) {
                    return '';
                }
                const refundPercent = (1 - +this.currentBoard.refundPercent / 100);
                return roundNumber(originalPredict * refundPercent);
            },
            applyRefund() {
                this.$emit('updateBoardProperty', 'refundPercent', this.localRefundPercent);
            },
            excelCopy(chart) {
                const rows = chart.data.datasets.map((dataset) => {
                    return [dataset.label].concat(dataset.data);
                });
                const columns = _.zip(...rows);
                copyToClipboard(columns.map(lines => lines.join('\t')).join('\n'));
            },
            generateCharts() {
                let maxLength = 0;
                this.charts = [];
                const eventsColors = getEventsWithData().map((event) => event.color);
                const chartsArray =
                    this.currentBoard.predictions.displays.concat(this.currentBoard.predictions[`products${this.currentPredictType}`] || []);
                chartsArray.forEach((product) => {
                    if (product.charts) {
                        const dataSets = [];
                        Object.entries(product.charts).forEach(([chartName, predictionValues], index) => {
                            maxLength = Math.max(predictionValues.length, maxLength);
                            dataSets.push({
                                backgroundColor: eventsColors[index],
                                borderColor: eventsColors[index],
                                data: predictionValues,
                                fill: false,
                                label: chartName,
                                tension: 0,
                                borderDash: [10, 5],
                            });
                        });
                        const labels = new Array(maxLength).fill('').map((data, index) => {
                            return index % 5 === 0 ? index : '';
                        });
                        this.charts.push({
                            data: {
                                datasets: dataSets,
                                labels,
                            },
                            options: {
                                title: {
                                    display: true,
                                    text: product.product_id || product.display_id,
                                }, responsive: true, maintainAspectRatio: false, plugins: {legend: true},
                            },
                        });
                    }
                });
                if (!this.currentBoard.tempData.predictionCharts) {
                    this.$set(this.currentBoard.tempData, 'predictionCharts', {});
                }
                this.currentBoard.tempData.predictionCharts[this.currentPredictType] = _.cloneDeep({
                    predictions: this.currentBoard.predictions,
                    charts: this.charts,
                });
            },
            changePopupVisibility(predictType) {
                this.isShowPopup = !this.isShowPopup;
                if (this.isShowPopup) {
                    this.currentPredictType = predictType;
                    if (this.currentBoard.tempData.predictionCharts && this.currentBoard.tempData.predictionCharts[this.currentPredictType]) {
                        const data = this.currentBoard.tempData.predictionCharts[this.currentPredictType];
                        this.currentBoard.predictions = data.predictions;
                        this.charts = data.charts;
                    } else {
                        delete this.currentBoard.predictions;
                        this.$emit('openSubscriptionPopup', predictType);
                    }
                } else {
                    this.currentPredictType = null;
                    this.charts = null;
                }
            },
            showTooltip(event, name, data) {
                this.$emit('showTooltip', event, name, data);
            },
            getSumByProperty(propertyName) {
                if (this.subscriptionsByRenewal[propertyName]) {
                    return this.subscriptionsByRenewal[propertyName].reduce(function (sum, subscription) {
                        return sum + subscription.count;
                    }, 0);
                }
                return 0;
            },

            getSubscriptionFromFeatureBundleId() {
                if (this.cohort) {
                    addTempBoardData(this.currentBoard, 'costsSubscription', +this.getSumByEventFromFeatureBundleId('expense'));
                    addTempBoardData(this.currentBoard, 'revenueSubscription', +this.getSumByEventFromFeatureBundleId('revenue'));
                }
            },
            getSumByEventFromFeatureBundleId(eventName) {
                const bundleIdFeature = this.features.find((feature) => feature.name === 'bundle_id');
                if (bundleIdFeature) {
                    const eventIndex = bundleIdFeature.events.findIndex((event) => event.name === eventName);
                    if (eventIndex >= 0) {
                        return bundleIdFeature.rows.reduce((acc, row) => {
                            return acc + +row.cells[eventIndex];
                        }, 0).toFixed(2);
                    }
                }
                return null;
            },
        },
    };
</script>

<style lang="scss">
  .predict-tooltip {
    td {
      vertical-align: middle;
      padding: 2px;
      text-align: right;

      .progress-vertical {
        margin-left: 10px;
      }
    }

  }
</style>

<style
    scoped
    lang="scss"
>
  .subscription {
    text-align: left;
    display: flex;
    height: 30px;
    margin-left: 21px;
    margin-top: 10px;
    margin-bottom: 30px;
    margin-right: 20px;
    align-items: center;

    .not-calculated {
      color: red;
    }

    &-all-time-label {
      border-radius: 12px;
      width: 71px;
      height: 24px;
      background: #E5EBFF;
      color: #6089E7;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__item {
      display: flex;
      border-right: 2px solid $light-blue-color;
      margin-right: 5px;
      padding-right: 5px;
      height: 100%;

      &_clickable {
        cursor: pointer;
      }

      &_loading {
        .VLoadingRow {
          margin-right: 25px;
        }

      }
    }

    &_last {
      border-right: none;
    }

    &__per {
      margin-top: 3px;
    }

    &__button-settings {
      width: 28px;
      height: 28px;
      cursor: pointer;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url('data:image/svg+xml;base64,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');
    }

    .popup-body {
      display: flex;

      &_text {
        width: 50%;
      }

      &_chart {
        width: 50%;
        position: fixed;
        right: 40px;
        overflow-y: scroll;
        height: calc(100vh - 120px);
        @include scrollbar-features-summary-styles ;

        &-copy {
          position: absolute;
          right: 10px;
          width: 90px;
        }
      }

      padding: 20px;
    }

    .subscription_last {
      margin-right: 0;
      display: flex;
      align-items: center;

      ::v-deep {
        .VChangableLabel {
          padding-right: 13px;
        }
      }
    }

    .refund {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;

      &__input {
        ::v-deep {
          input {
            width: 30px;
            font-size: 14px;
          }
        }
      }

      ::v-deep {
        .VButton {
          margin-left: 5px;
          padding: 6px 5px 7px 5px;
          font-size: 14px;

          &__title {
            margin-right: 0px;
          }
        }
      }

    }
  }
</style>
